export default {
    url: '',
    template: '<manage-permissions-roles-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/roles/list/index.js